// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"521":"0be4f82c","725":"ef67a121","4542":"23784e98","5695":"59f2a80b","7387":"13bb3be4","9387":"6d6fe353"}[chunkId] + ".css";
};